import type { ReactNode } from 'react';

import { m } from 'motion/react';
import type { PreviewTab } from '../../../learnBasicsTypes';

export type TourPreviewTab = {
  id: PreviewTab;
  label: string;
  icon: ReactNode;
};

/**
 * Guided-tour tab strip. Unlike the control arm's tabs — which live inside the
 * note card's header and can be closed — these pills float on the pane's photo
 * backdrop above the card and only ever accumulate, so the strip reads as a
 * trail of everything the tour has produced so far.
 */
export function TourPreviewTabs({
  tabs,
  activeTab,
  onSelect,
}: {
  tabs: TourPreviewTab[];
  activeTab: PreviewTab;
  onSelect: (tab: PreviewTab) => void;
}) {
  return (
    <div className="flex shrink-0 items-center gap-2 overflow-x-auto pb-1">
      {tabs.map((tab) => {
        const isActive = tab.id === activeTab;
        return (
          <m.button
            key={tab.id}
            type="button"
            onClick={() => onSelect(tab.id)}
            data-state={isActive ? 'active' : 'unchecked'}
            initial={{ opacity: 0, scale: 0.95 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.15 }}
            className={`flex shrink-0 items-center gap-1.5 whitespace-nowrap rounded-md px-2.5 py-2 text-xs font-medium text-text-primary shadow-sm transition-colors ${
              isActive ? 'bg-surface' : 'bg-surface/50 hover:bg-surface/70'
            }`}
          >
            {tab.icon}
            {tab.label}
          </m.button>
        );
      })}
    </div>
  );
}
